<template>
    <span class="ui-spinner" :style="{ width: size + 'px', height: size + 'px' }" />
</template>

<script>
export default {
    name: 'UiSpinner',
    props: {
        size: { type: [String, Number], default: 24 },
    },
};
</script>

<style scoped>
.ui-spinner {
    display: inline-block;
    border-radius: 50%;
    border: 3px solid var(--c-border);
    border-top-color: var(--c-primary);
    animation: ui-spinner-spin 0.7s linear infinite;
}

@keyframes ui-spinner-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
